import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import AboutSection from '../components/AboutSection';
import ContactSection from '../components/ContactSection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
import { useLanguage } from '../context/LanguageContext';

const LandingPage = () => {
  const { language } = useLanguage();
  
  return (
    <main className="min-h-screen bg-[#0A0A0B] relative" data-testid="landing-page">
      <SEO 
        title={language === 'es' ? null : null}
        description={language === 'es' 
          ? 'Transformamos tu negocio con desarrollo de software a medida, implementación de IA y digitalización. Oficinas en Miami, Quito y Londres.'
          : 'We transform your business with custom software development, AI implementation, and digitalization. Offices in Miami, Quito, and London.'}
        url="/"
      />
      <Navbar />
      <HeroSection />
      <ServicesSection />
      <AboutSection />
      <ContactSection />
      <Footer />
    </main>
  );
};

export default LandingPage;
